export default __webpack_public_path__ + "static/videoframe_0-a1be0c49417f8d01f51548ef1aa9337b.jpg";